/* SALES DATA LOAD (2026-10-22) — the screen that runs Max's weekly CW sales update as a job. */
const en = {
  title: 'Sales Data Update',
  sub: 'SAP (HINC) and NetSuite (HUSA, HEMA, HPAC) are read directly; the HJPN workbook is uploaded. The window runs from the day after the closed date (else the 1st of last month) to yesterday.',
  window: 'Window',
  cronOn: 'Runs by itself every morning at 06:15',
  cronOff: 'The morning run is not armed on this server',
  running: 'A load is running…',
  tab_runs: 'Runs',
  tab_customers: 'New customers',
  tab_skus: 'New SKUs',
  tab_held: 'Held rows',
  tab_hjpn: 'HJPN workbook',
  from: 'From',
  to: 'To',
  sources: 'Sources',
  preview: 'Preview (no change)',
  load: 'Load into the fact table',
  loadConfirm: 'Replace the sales of {{regions}} from {{from}} to {{to}} in 03_ERP_TransactionSalesCW_ft with what SAP and NetSuite hold now? The rows replaced are kept and can be put back.',
  loadOk: 'Load',
  colRun: 'Run',
  colWhen: 'Started',
  colStatus: 'Status',
  colBy: 'By',
  colRange: 'Range',
  colSources: 'Sources',
  colRows: 'Rows',
  colResult: 'Result',
  colAction: 'Action',
  st_running: 'Running',
  st_ok: 'Loaded',
  st_dry: 'Preview',
  st_would: 'Would load',
  st_partial: 'Partly loaded',
  st_error: 'Failed',
  st_rolled_back: 'Put back',
  trig_cron: 'Morning run',
  trig_manual: 'By hand',
  trig_hjpn: 'HJPN upload',
  trig_held: 'Held rows',
  rowsLine: '{{loaded}} to load · {{held}} held',
  detail: 'Details',
  putBack: 'Put back',
  putBackConfirm: 'Remove what run #{{id}} loaded and put back the rows it replaced?',
  before: 'In the table before',
  staged: 'This run',
  region: 'Entity',
  rows: 'Rows',
  qty: 'Qty',
  net: 'Net',
  days: 'Days',
  internalRows: 'Intercompany',
  exInternal: 'excl. intercompany',
  exInternalHint: 'Quantity and net leave intercompany rows out; Rows counts every row and Intercompany says how many are internal.',
  inclInternalOld: 'An older run: this figure still includes intercompany rows. Press Preview again for the figure without them.',
  lastDay: 'Last day',
  heldWhy: 'Why rows were held',
  log: 'Log',
  noRuns: 'No run yet.',
  refresh: 'Refresh',
  factNow: 'In the fact table now',
  // pending customers
  custHint: 'Customers the sources sell to that 02_ERP_Customer_ft does not know. Fill in what the source could not say, then Add — the rows held for the customer load at once.',
  skuHint: 'SKUs the sources sold that 01_PLM_Product_ft does not know. Fill in the description and the collection at least, then Add — the rows held for the SKU load at once.',
  colId: 'ID',
  colName: 'Name',
  colNameKr: 'Name (KR)',
  colSourceType: 'Source says',
  colType: 'Customer type',
  colTypeCw: 'Type (CW)',
  colDistrict: 'District',
  colCity: 'City',
  colState: 'State / province',
  colCountry: 'Country',
  colHeld: 'Rows held',
  colSeen: 'Seen in run',
  save: 'Save',
  add: 'Add',
  dismiss: 'Dismiss',
  dismissed: 'Dismissed',
  added: 'Added',
  noPending: 'Nothing waiting.',
  colSku: 'SKU',
  colSapCode: 'SAP code',
  colDesc: 'Description',
  colColorway: 'Colorway',
  colSize: 'Size',
  colCollection: 'Collection',
  colFrameModel: 'Frame model',
  colFrameColor: 'Frame colour',
  colCategory: 'NS category',
  colNsType: 'NS type',
  colSubtype: 'NS subtype',
  colRef: 'Source said',
  pick: '— pick —',
  // held
  heldHint: 'Rows worked out but not loaded, each with its reason. Once the customer or SKU exists, "Load held rows" puts them in without touching anything else. A row held by a Preview is not loaded this way — the next Load reads it again from the source.',
  loadHeldConfirm: 'Load the held rows whose customer and SKU now exist into the fact table? {{n}} rows are held; only those that resolve go in, nothing is deleted.',
  flashCounts: '{{n}} {{what}} / {{held}} held',
  heldPreview: '{{n}} held rows come from a Preview — press "Load into the fact table": they are read again from the source with the customer and SKU now known.',
  closedThrough: 'Closed through', closedHint: 'The last day already signed off. A load starts the day after it; the morning run too.', closedLine: 'Sales through {{day}} are closed — a load starts {{from}}.', closedNone: 'No closed date yet — the window is the 1st of last month to yesterday.', closedSaved: 'Closed through {{day}} — loads start {{from}}.',
  cacheNote: 'the Sales Report cache is being refreshed in the background (about 5 minutes) — the dashboard shows the new figures once it ends', cacheRefreshing: 'Sales Report cache refreshing…', cacheDone: 'cache {{s}}s', cacheFailed: 'cache refresh failed',
  tourTabsT: 'Five tabs, one flow — this guide walks it in order', tourTabsB: 'Runs is where a load is previewed and started. New customers and New SKUs hold what the sources sent that the portal does not know yet — fill them in and Add, and the rows held for them load. Held rows lists what waits. HJPN workbook uploads the file you keep by hand.',
  tourClosedT: '1. Set the closed date', tourClosedB: 'The last day already signed off. The window starts the day after it and a load into a closed day is refused. Move it forward once a month is final.',
  tourWindowT: '2. Check the window and the sources', tourWindowB: 'From and To are the days read from SAP (HINC) and NetSuite (HUSA, HEMA, HPAC). From defaults to the day after the closed date, To to yesterday.',
  tourPreviewT: '3. Preview', tourPreviewB: 'Reads the sources and stages every row without touching the fact table. The run row says how many would load and how many are held for an unknown customer or SKU.',
  tourLoadT: '7. Load into the fact table', tourLoadB: 'Replaces the window in the fact table — after a backup, in one transaction — then the Sales Report cache is refreshed in the background (about 5 minutes). Put back on the run row restores the backup.',
  tourFactT: '9. Check what the fact table holds now', tourFactB: 'Per region: how many rows sit in the window and the last sales day loaded. Compare it with a Preview before loading.',
  tourRunsT: '10. Every run, and Put back', tourRunsB: 'Preview and Load alike. Detail opens the staged rows and the log; Put back undoes a load. Sort and filter the columns like Excel.',
  tourCustT: '4. New customers: fill in and Add', tourSkusT: '5. New SKUs: fill in and Add', tourSkusB: 'A SKU the sources sent and the portal does not know. Translate names to English words a Korean name; type what is missing, Save keeps your typing, Add writes the SKU and loads the rows held for it.', tourPendingB: 'A customer or SKU the sources sent and the portal does not know. Type what is missing, Save keeps your typing, Add writes it to the dimension and loads the rows held for it.',
  tourHeldT: '6. Held rows', tourHeldB: 'Rows a run could not load — an unknown customer or SKU, an unmapped channel, a date outside the window. Load held rows takes those whose customer and SKU now exist.',
  tourHjpnT: '8. The HJPN workbook', tourHjpnB: 'Choose the file, Preview to read it, Load HJPN to replace HJPN inside the window. Rows outside the window are not touched.',
  nOfN: '{{n}} of {{total}} rows', clearFilters: 'Clear filters',
  translate: 'Translate names to English', translateHint: 'A Korean name is translated by Claude; the original stays under Source said.', translated: '{{n}} names translated, {{left}} left as they were', translateNoAi: 'No AI key on this server — the names stay as they came.',
  loadHeld: 'Load held rows',
  heldLoaded: '{{n}} rows loaded, {{left}} still held.',
  colDate: 'Date',
  colDoc: 'Document',
  colCustomer: 'Customer',
  colChannel: 'Channel',
  colReason: 'Reason',
  // hjpn
  hjpnHint: 'The HJPN workbook you keep by hand (sheets "REVENUE - B&M SALE" and "REVENUE - ONLINE <year>"). Rows inside the window replace HJPN in the fact table for that window; nothing else is touched.',
  chooseFile: 'Choose the workbook…',
  hjpnPreview: 'Preview',
  hjpnLoad: 'Load HJPN',
  hjpnConfirm: 'Replace HJPN from {{from}} to {{to}} with the rows of this workbook?',
  issues: 'Rows whose figures do not add up (the notebook stopped on these; here they are listed and loaded as the sheet says):',
  working: 'Working…',
  done: 'Done.',
  error: 'Error',
};
const ko = {
  title: '판매 데이터 업데이트',
  sub: 'SAP(HINC)와 NetSuite(HUSA, HEMA, HPAC)는 직접 읽고, HJPN 워크북은 업로드합니다. 기간은 마감일 다음 날(없으면 지난달 1일)부터 어제까지입니다.',
  window: '기간', cronOn: '매일 아침 06:15에 자동 실행', cronOff: '이 서버에서는 아침 실행이 꺼져 있습니다', running: '적재 실행 중…',
  tab_runs: '실행', tab_customers: '신규 고객', tab_skus: '신규 SKU', tab_held: '보류 행', tab_hjpn: 'HJPN 워크북',
  from: '시작', to: '종료', sources: '소스', preview: '미리보기 (변경 없음)', load: '팩트 테이블에 적재',
  loadConfirm: '{{from}}부터 {{to}}까지 {{regions}}의 판매를 SAP와 NetSuite의 현재 값으로 03_ERP_TransactionSalesCW_ft에서 교체할까요? 교체된 행은 보관되어 되돌릴 수 있습니다.',
  loadOk: '적재', colRun: '실행', colWhen: '시작', colStatus: '상태', colBy: '실행자', colRange: '기간', colSources: '소스', colRows: '행', colResult: '결과', colAction: '작업',
  st_running: '실행 중', st_ok: '적재됨', st_dry: '미리보기', st_would: '적재 예정', st_partial: '일부 적재', st_error: '실패', st_rolled_back: '되돌림',
  trig_cron: '아침 실행', trig_manual: '수동', trig_hjpn: 'HJPN 업로드', trig_held: '보류 행',
  rowsLine: '{{loaded}} 적재 · {{held}} 보류', detail: '상세', putBack: '되돌리기', putBackConfirm: '실행 #{{id}}이 적재한 내용을 제거하고 교체된 행을 되돌릴까요?',
  before: '적재 전 테이블', staged: '이번 실행', region: '법인', rows: '행', internalRows: '관계사 거래', exInternal: '관계사 거래 제외', exInternalHint: '수량과 순매출은 관계사 거래 행을 제외합니다. 행은 모든 행을, 관계사 거래는 그중 내부 거래 수를 셉니다.', inclInternalOld: '이전 실행: 이 수치에는 관계사 거래가 포함되어 있습니다. 미리보기를 다시 누르면 제외된 수치가 나옵니다.', qty: '수량', net: '순매출', days: '일수', lastDay: '마지막 날', heldWhy: '보류 사유', log: '로그', noRuns: '아직 실행이 없습니다.', refresh: '새로고침', factNow: '현재 팩트 테이블',
  custHint: '소스에 있지만 02_ERP_Customer_ft에 없는 고객입니다. 소스가 알려주지 못한 항목을 채우고 추가하면 보류된 행이 바로 적재됩니다.',
  skuHint: '소스에 팔렸지만 01_PLM_Product_ft에 없는 SKU입니다. 최소한 설명과 컬렉션을 채우고 추가하면 보류된 행이 바로 적재됩니다.',
  colId: 'ID', colName: '이름', colNameKr: '이름(KR)', colSourceType: '소스 값', colType: '고객 유형', colTypeCw: '유형(CW)', colDistrict: '구', colCity: '도시', colState: '주/도', colCountry: '국가', colHeld: '보류 행', colSeen: '확인 실행',
  save: '저장', add: '추가', dismiss: '제외', dismissed: '제외됨', added: '추가됨', noPending: '대기 중인 항목이 없습니다.',
  colSku: 'SKU', colSapCode: 'SAP 코드', colDesc: '설명', colColorway: '컬러웨이', colSize: '사이즈', colCollection: '컬렉션', colFrameModel: '프레임 모델', colFrameColor: '프레임 색상', colCategory: 'NS 카테고리', colNsType: 'NS 유형', colSubtype: 'NS 하위 유형', colRef: '소스 값', pick: '— 선택 —',
  heldHint: '계산되었지만 적재되지 않은 행과 그 사유입니다. 고객이나 SKU가 생기면 "보류 행 적재"로 다른 것은 건드리지 않고 넣습니다. 미리보기에서 보류된 행은 이 방식으로 적재되지 않고, 다음 적재 때 원천에서 다시 읽습니다.',
  loadHeldConfirm: '고객과 SKU가 이제 존재하는 보류 행을 사실 테이블에 적재할까요? 보류 행 {{n}}개 중 해결된 행만 들어가며, 삭제되는 것은 없습니다.',
  flashCounts: '{{n}} {{what}} / 보류 {{held}}',
  heldPreview: '보류 {{n}}행은 미리보기에서 나온 것입니다. "사실 테이블에 적재"를 누르면 고객·SKU가 생긴 상태로 원천에서 다시 읽습니다.',
  closedThrough: '마감일', closedHint: '이미 확정된 마지막 날. 적재는 그 다음 날부터 시작하며 아침 실행도 같습니다.', closedLine: '{{day}}까지의 매출은 마감되었습니다 — 적재는 {{from}}부터.', closedNone: '아직 마감일이 없습니다 — 기간은 지난달 1일부터 어제까지입니다.', closedSaved: '{{day}}까지 마감 — 적재는 {{from}}부터.',
  cacheNote: 'Sales Report 캐시를 백그라운드에서 갱신 중입니다(약 5분) — 끝나면 대시보드에 새 수치가 보입니다', cacheRefreshing: 'Sales Report 캐시 갱신 중…', cacheDone: '캐시 {{s}}초', cacheFailed: '캐시 갱신 실패',
  tourTabsT: '다섯 개 탭, 하나의 흐름 — 이 가이드가 순서대로 안내합니다', tourTabsB: 'Runs에서 적재를 미리 보고 시작합니다. New customers와 New SKUs에는 소스가 보냈지만 포털이 아직 모르는 항목이 있습니다 — 채우고 Add를 누르면 보류된 행이 적재됩니다. Held rows는 대기 중인 행, HJPN workbook은 수작업 파일 업로드입니다.',
  tourClosedT: '1. 마감일 설정', tourClosedB: '이미 확정된 마지막 날입니다. 기간은 그 다음 날부터 시작하며 마감된 날로의 적재는 거부됩니다. 한 달이 확정되면 앞으로 옮기세요.',
  tourWindowT: '2. 기간과 소스 확인', tourWindowB: 'From과 To는 SAP(HINC)와 NetSuite(HUSA, HEMA, HPAC)에서 읽는 날짜입니다. From은 마감일 다음 날, To는 어제가 기본값입니다.',
  tourPreviewT: '3. Preview', tourPreviewB: '소스를 읽어 모든 행을 스테이징하되 팩트 테이블은 건드리지 않습니다. 실행 행에 적재될 수와 알 수 없는 고객·SKU로 보류된 수가 표시됩니다.',
  tourLoadT: '7. 팩트 테이블에 적재', tourLoadB: '백업 후 한 트랜잭션으로 기간을 교체하고, Sales Report 캐시를 백그라운드에서 갱신합니다(약 5분). 실행 행의 Put back이 백업을 복원합니다.',
  tourFactT: '9. 현재 팩트 테이블 확인', tourFactB: '지역별로 기간 안의 행 수와 마지막 적재 판매일입니다. 적재 전에 Preview와 비교하세요.',
  tourRunsT: '10. 모든 실행과 Put back', tourRunsB: 'Preview와 Load 모두. Detail은 스테이징 행과 로그를 열고, Put back은 적재를 되돌립니다. 열은 Excel처럼 정렬·필터할 수 있습니다.',
  tourCustT: '4. New customers: 채우고 Add', tourSkusT: '5. New SKUs: 채우고 Add', tourSkusB: '소스가 보냈지만 포털이 모르는 SKU입니다. Translate names to English가 한국어 이름을 영어로 옮깁니다. 빠진 값을 입력하고 Save로 보관, Add로 SKU를 쓰고 보류된 행을 적재합니다.', tourPendingB: '소스가 보냈지만 포털이 모르는 고객 또는 SKU입니다. 빠진 값을 입력하고 Save로 보관, Add로 차원에 쓰고 보류된 행을 적재합니다.',
  tourHeldT: '6. 보류된 행', tourHeldB: '실행이 적재하지 못한 행 — 알 수 없는 고객·SKU, 매핑되지 않은 채널, 기간 밖의 날짜. Load held rows는 고객과 SKU가 이제 존재하는 행을 적재합니다.',
  tourHjpnT: '8. HJPN 워크북', tourHjpnB: '파일을 선택하고 Preview로 읽은 뒤 Load HJPN으로 기간 안의 HJPN을 교체합니다. 기간 밖의 행은 건드리지 않습니다.',
  nOfN: '{{total}}행 중 {{n}}행', clearFilters: '필터 해제',
  translate: '이름을 영어로 번역', translateHint: '한국어 이름은 Claude가 번역하며 원문은 Source said에 남습니다.', translated: '{{n}}개 번역됨, {{left}}개 그대로', translateNoAi: '이 서버에 AI 키가 없어 이름을 그대로 둡니다.',
  loadHeld: '보류 행 적재', heldLoaded: '{{n}}행 적재, {{left}}행 보류 중.', colDate: '날짜', colDoc: '문서', colCustomer: '고객', colChannel: '채널', colReason: '사유',
  hjpnHint: '직접 관리하는 HJPN 워크북(시트 "REVENUE - B&M SALE", "REVENUE - ONLINE <연도>")입니다. 기간 안의 행이 해당 기간의 HJPN을 교체하며, 다른 것은 건드리지 않습니다.',
  chooseFile: '워크북 선택…', hjpnPreview: '미리보기', hjpnLoad: 'HJPN 적재', hjpnConfirm: '{{from}}부터 {{to}}까지 HJPN을 이 워크북의 행으로 교체할까요?',
  issues: '숫자가 맞지 않는 행(노트북은 여기서 멈췄지만, 여기서는 시트대로 적재하고 목록으로 보여줍니다):', working: '처리 중…', done: '완료.', error: '오류',
};
const vi = {
  title: 'Cập nhật dữ liệu bán hàng',
  sub: 'SAP (HINC) và NetSuite (HUSA, HEMA, HPAC) được đọc trực tiếp; file HJPN thì upload. Cửa sổ chạy từ ngày sau ngày chốt (nếu chưa có thì mùng 1 tháng trước) đến hôm qua.',
  window: 'Khoảng', cronOn: 'Tự chạy mỗi sáng lúc 06:15', cronOff: 'Server này không bật chạy sáng', running: 'Đang nạp…',
  tab_runs: 'Lần chạy', tab_customers: 'Khách hàng mới', tab_skus: 'SKU mới', tab_held: 'Dòng chờ', tab_hjpn: 'File HJPN',
  from: 'Từ', to: 'Đến', sources: 'Nguồn', preview: 'Xem trước (không đổi gì)', load: 'Nạp vào bảng fact',
  loadConfirm: 'Thay doanh số của {{regions}} từ {{from}} đến {{to}} trong 03_ERP_TransactionSalesCW_ft bằng số SAP và NetSuite đang có? Các dòng bị thay được giữ lại và có thể đưa về.',
  loadOk: 'Nạp', colRun: 'Lần', colWhen: 'Bắt đầu', colStatus: 'Trạng thái', colBy: 'Người chạy', colRange: 'Khoảng', colSources: 'Nguồn', colRows: 'Dòng', colResult: 'Kết quả', colAction: 'Thao tác',
  st_running: 'Đang chạy', st_ok: 'Đã nạp', st_dry: 'Xem trước', st_would: 'Sẽ nạp', st_partial: 'Nạp một phần', st_error: 'Lỗi', st_rolled_back: 'Đã đưa về',
  trig_cron: 'Chạy sáng', trig_manual: 'Chạy tay', trig_hjpn: 'Upload HJPN', trig_held: 'Dòng chờ',
  rowsLine: '{{loaded}} nạp · {{held}} chờ', detail: 'Chi tiết', putBack: 'Đưa về', putBackConfirm: 'Gỡ những gì lần chạy #{{id}} đã nạp và đưa các dòng bị thay về lại?',
  before: 'Trong bảng trước đó', staged: 'Lần này', region: 'Entity', rows: 'Dòng', internalRows: 'Intercompany', exInternal: 'không tính intercompany', exInternalHint: 'SL và Net không tính các dòng intercompany; Dòng đếm mọi dòng, cột Intercompany cho biết bao nhiêu dòng là nội bộ.', inclInternalOld: 'Lần chạy cũ: số này vẫn tính cả intercompany. Bấm Xem trước lại để có số không tính intercompany.', qty: 'SL', net: 'Net', days: 'Số ngày', lastDay: 'Ngày cuối', heldWhy: 'Lý do dòng bị chờ', log: 'Nhật ký', noRuns: 'Chưa có lần chạy nào.', refresh: 'Tải lại', factNow: 'Bảng fact hiện tại',
  custHint: 'Khách hàng có trong nguồn mà 02_ERP_Customer_ft chưa có. Điền phần nguồn không nói, rồi bấm Thêm — các dòng đang chờ khách này sẽ nạp ngay.',
  skuHint: 'SKU đã bán trong nguồn mà 01_PLM_Product_ft chưa có. Điền tối thiểu mô tả và collection, rồi bấm Thêm — các dòng đang chờ SKU này sẽ nạp ngay.',
  colId: 'ID', colName: 'Tên', colNameKr: 'Tên (KR)', colSourceType: 'Nguồn ghi', colType: 'Loại khách', colTypeCw: 'Loại (CW)', colDistrict: 'Quận', colCity: 'Thành phố', colState: 'Bang / tỉnh', colCountry: 'Quốc gia', colHeld: 'Dòng chờ', colSeen: 'Thấy ở lần',
  save: 'Lưu', add: 'Thêm', dismiss: 'Bỏ qua', dismissed: 'Đã bỏ qua', added: 'Đã thêm', noPending: 'Không có gì đang chờ.',
  colSku: 'SKU', colSapCode: 'Mã SAP', colDesc: 'Mô tả', colColorway: 'Màu', colSize: 'Size', colCollection: 'Collection', colFrameModel: 'Frame model', colFrameColor: 'Màu frame', colCategory: 'NS category', colNsType: 'NS type', colSubtype: 'NS subtype', colRef: 'Nguồn ghi', pick: '— chọn —',
  heldHint: 'Những dòng đã tính nhưng chưa nạp, kèm lý do. Khi khách hoặc SKU đã có, "Nạp dòng chờ" sẽ đưa vào mà không đụng gì khác. Dòng chờ của một lần Xem trước không nạp theo cách này — lần Nạp kế tiếp sẽ đọc lại từ nguồn.',
  loadHeldConfirm: 'Nạp vào bảng fact những dòng chờ mà khách và SKU nay đã có? Đang chờ {{n}} dòng; chỉ dòng nào khớp mới vào, không xóa gì.',
  flashCounts: '{{n}} {{what}} / {{held}} chờ',
  heldPreview: '{{n}} dòng chờ là của một lần Xem trước — bấm "Load into the fact table": chúng được đọc lại từ nguồn với khách và SKU nay đã có.',
  closedThrough: 'Đã chốt đến', closedHint: 'Ngày cuối đã chốt số. Lần nạp bắt đầu từ ngày kế tiếp; chạy sáng cũng vậy.', closedLine: 'Doanh thu đến {{day}} đã chốt — nạp từ {{from}}.', closedNone: 'Chưa có ngày chốt — cửa sổ là mùng 1 tháng trước đến hôm qua.', closedSaved: 'Đã chốt đến {{day}} — nạp từ {{from}}.',
  cacheNote: 'cache của Sales Report đang được làm mới ngầm (khoảng 5 phút) — dashboard hiện số mới khi xong', cacheRefreshing: 'Đang làm mới cache Sales Report…', cacheDone: 'cache {{s}} giây', cacheFailed: 'làm mới cache thất bại',
  tourTabsT: 'Năm tab, một quy trình — hướng dẫn này đi theo đúng thứ tự', tourTabsB: 'Runs là nơi xem trước và chạy nạp. New customers và New SKUs chứa những gì nguồn gửi mà portal chưa biết — điền rồi bấm Add, các dòng đang giữ vì chúng sẽ được nạp. Held rows là các dòng đang chờ. HJPN workbook để upload file anh giữ bằng tay.',
  tourClosedT: '1. Đặt ngày chốt', tourClosedB: 'Ngày cuối đã chốt số. Cửa sổ bắt đầu từ ngày kế tiếp và nạp vào ngày đã chốt sẽ bị từ chối. Chốt xong tháng nào thì tiến ngày này lên.',
  tourWindowT: '2. Kiểm tra cửa sổ và nguồn', tourWindowB: 'From và To là khoảng ngày đọc từ SAP (HINC) và NetSuite (HUSA, HEMA, HPAC). From mặc định là ngày sau ngày chốt, To là hôm qua.',
  tourPreviewT: '3. Preview', tourPreviewB: 'Đọc nguồn và stage mọi dòng nhưng không chạm vào bảng fact. Dòng run cho biết bao nhiêu dòng sẽ nạp và bao nhiêu bị giữ vì khách hàng hay SKU chưa biết.',
  tourLoadT: '7. Load vào bảng fact', tourLoadB: 'Thay thế cửa sổ trong bảng fact — sau khi backup, trong một transaction — rồi làm mới cache Sales Report ngầm (khoảng 5 phút). Put back trên dòng run khôi phục bản backup.',
  tourFactT: '9. Kiểm tra bảng fact hiện có gì', tourFactB: 'Theo từng region: số dòng trong cửa sổ và ngày bán cuối đã nạp. So với Preview trước khi nạp.',
  tourRunsT: '10. Mọi lần chạy, và Put back', tourRunsB: 'Cả Preview lẫn Load. Detail mở các dòng đã stage và log; Put back hoàn tác một lần nạp. Sort và filter cột như Excel.',
  tourCustT: '4. New customers: điền rồi Add', tourSkusT: '5. New SKUs: điền rồi Add', tourSkusB: 'SKU nguồn gửi mà portal chưa biết. Translate names to English dịch tên tiếng Hàn sang tiếng Anh; gõ phần còn thiếu, Save giữ lại, Add ghi SKU và nạp các dòng đang giữ vì nó.', tourPendingB: 'Khách hàng hay SKU nguồn gửi mà portal chưa biết. Gõ phần còn thiếu, Save giữ lại, Add ghi vào dimension và nạp các dòng đang giữ vì nó.',
  tourHeldT: '6. Dòng đang giữ', tourHeldB: 'Những dòng một lần chạy không nạp được — khách hàng hay SKU chưa biết, channel chưa map, ngày ngoài cửa sổ. Load held rows nạp những dòng mà khách hàng và SKU giờ đã có.',
  tourHjpnT: '8. File HJPN', tourHjpnB: 'Chọn file, Preview để đọc, Load HJPN để thay HJPN trong cửa sổ. Dòng ngoài cửa sổ không bị đụng tới.',
  nOfN: '{{n}} / {{total}} dòng', clearFilters: 'Bỏ lọc',
  translate: 'Dịch tên sang tiếng Anh', translateHint: 'Tên tiếng Hàn do Claude dịch; bản gốc giữ ở cột Source said.', translated: 'Đã dịch {{n}} tên, {{left}} tên giữ nguyên', translateNoAi: 'Server này không có khóa AI — tên giữ nguyên.',
  loadHeld: 'Nạp dòng chờ', heldLoaded: 'Đã nạp {{n}} dòng, còn chờ {{left}}.', colDate: 'Ngày', colDoc: 'Chứng từ', colCustomer: 'Khách', colChannel: 'Kênh', colReason: 'Lý do',
  hjpnHint: 'File HJPN anh tự xử lý (sheet "REVENUE - B&M SALE" và "REVENUE - ONLINE <năm>"). Các dòng trong khoảng sẽ thay HJPN của khoảng đó trong bảng fact; không đụng gì khác.',
  chooseFile: 'Chọn file…', hjpnPreview: 'Xem trước', hjpnLoad: 'Nạp HJPN', hjpnConfirm: 'Thay HJPN từ {{from}} đến {{to}} bằng các dòng trong file này?',
  issues: 'Các dòng có số không khớp (notebook dừng ở đây; ở đây vẫn nạp theo sheet và liệt kê ra):', working: 'Đang xử lý…', done: 'Xong.', error: 'Lỗi',
};
const zh = {
  title: '销售数据更新',
  sub: '直接读取 SAP（HINC）和 NetSuite（HUSA、HEMA、HPAC）；HJPN 工作簿由上传提供。时间范围为结账日的次日（未设则为上月 1 日）至昨天。',
  window: '范围', cronOn: '每天早上 06:15 自动运行', cronOff: '此服务器未启用早间运行', running: '正在加载…',
  tab_runs: '运行记录', tab_customers: '新客户', tab_skus: '新 SKU', tab_held: '暂挂行', tab_hjpn: 'HJPN 工作簿',
  from: '从', to: '至', sources: '数据源', preview: '预览（不改动）', load: '加载到事实表',
  loadConfirm: '用 SAP 和 NetSuite 当前数据替换 03_ERP_TransactionSalesCW_ft 中 {{regions}} 从 {{from}} 到 {{to}} 的销售？被替换的行会保留并可恢复。',
  loadOk: '加载', colRun: '运行', colWhen: '开始', colStatus: '状态', colBy: '执行人', colRange: '范围', colSources: '数据源', colRows: '行数', colResult: '结果', colAction: '操作',
  st_running: '运行中', st_ok: '已加载', st_dry: '预览', st_would: '将加载', st_partial: '部分加载', st_error: '失败', st_rolled_back: '已恢复',
  trig_cron: '早间运行', trig_manual: '手动', trig_hjpn: 'HJPN 上传', trig_held: '暂挂行',
  rowsLine: '{{loaded}} 加载 · {{held}} 暂挂', detail: '详情', putBack: '恢复', putBackConfirm: '移除运行 #{{id}} 加载的内容并恢复被替换的行？',
  before: '加载前的表', staged: '本次运行', region: '实体', rows: '行数', internalRows: '关联公司交易', exInternal: '不含关联公司交易', exInternalHint: '数量和净额不含关联公司交易行；行数计所有行，关联公司交易列显示其中内部交易的行数。', inclInternalOld: '较早的运行：此数字仍包含关联公司交易。再次点击预览可得到不含的数字。', qty: '数量', net: '净额', days: '天数', lastDay: '最后一天', heldWhy: '暂挂原因', log: '日志', noRuns: '尚无运行记录。', refresh: '刷新', factNow: '当前事实表',
  custHint: '数据源中出现但 02_ERP_Customer_ft 中没有的客户。补齐数据源无法提供的信息后点击添加，为该客户暂挂的行会立即加载。',
  skuHint: '数据源中售出但 01_PLM_Product_ft 中没有的 SKU。至少填写描述和系列后点击添加，为该 SKU 暂挂的行会立即加载。',
  colId: 'ID', colName: '名称', colNameKr: '名称（韩文）', colSourceType: '来源值', colType: '客户类型', colTypeCw: '类型（CW）', colDistrict: '区', colCity: '城市', colState: '州/省', colCountry: '国家', colHeld: '暂挂行', colSeen: '出现于运行',
  save: '保存', add: '添加', dismiss: '忽略', dismissed: '已忽略', added: '已添加', noPending: '没有待处理项。',
  colSku: 'SKU', colSapCode: 'SAP 代码', colDesc: '描述', colColorway: '配色', colSize: '尺寸', colCollection: '系列', colFrameModel: '框架型号', colFrameColor: '框架颜色', colCategory: 'NS 类别', colNsType: 'NS 类型', colSubtype: 'NS 子类型', colRef: '来源值', pick: '— 选择 —',
  heldHint: '已计算但未加载的行及其原因。客户或 SKU 存在后，“加载暂挂行”会将其写入而不触及其他内容。预览中暂挂的行不会以此方式加载——下次加载会从来源重新读取。',
  loadHeldConfirm: '将客户和 SKU 现已存在的暂挂行加载到事实表？当前暂挂 {{n}} 行；只有能解析的行会写入，不删除任何内容。',
  flashCounts: '{{n}} {{what}} / 暂挂 {{held}}',
  heldPreview: '{{n}} 行暂挂来自预览——请点击“加载到事实表”：客户和 SKU 已存在，将从来源重新读取。',
  closedThrough: '已结账至', closedHint: '已确认的最后一天。加载从其次日开始；早间运行亦然。', closedLine: '截至 {{day}} 的销售已结账——加载从 {{from}} 开始。', closedNone: '尚无结账日期——范围为上月 1 日至昨天。', closedSaved: '已结账至 {{day}}——加载从 {{from}} 开始。',
  cacheNote: 'Sales Report 缓存正在后台刷新（约 5 分钟）——完成后仪表板显示新数据', cacheRefreshing: 'Sales Report 缓存刷新中…', cacheDone: '缓存 {{s}} 秒', cacheFailed: '缓存刷新失败',
  tourTabsT: '五个标签，一个流程——本指南按顺序带您走一遍', tourTabsB: 'Runs 用于预览并启动加载。New customers 和 New SKUs 存放来源发来但门户尚不认识的项目——填写后点 Add，为其保留的行即被加载。Held rows 列出等待中的行，HJPN workbook 上传手工维护的文件。',
  tourClosedT: '1. 设置结账日期', tourClosedB: '已确认的最后一天。时间范围从其次日开始，加载到已结账日期会被拒绝。每月定稿后把它往前移。',
  tourWindowT: '2. 检查时间范围与来源', tourWindowB: 'From 和 To 是从 SAP（HINC）和 NetSuite（HUSA、HEMA、HPAC）读取的日期。From 默认为结账日次日，To 为昨天。',
  tourPreviewT: '3. Preview', tourPreviewB: '读取来源并暂存每一行，但不触碰事实表。运行行显示将加载多少行、因未知客户或 SKU 保留多少行。',
  tourLoadT: '7. 加载到事实表', tourLoadB: '备份后在一个事务中替换该时间范围，然后在后台刷新 Sales Report 缓存（约 5 分钟）。运行行上的 Put back 可恢复备份。',
  tourFactT: '9. 检查事实表当前内容', tourFactB: '按区域：时间范围内的行数和已加载的最后销售日。加载前与 Preview 对比。',
  tourRunsT: '10. 每次运行与 Put back', tourRunsB: 'Preview 与 Load 都在此。Detail 打开暂存行和日志；Put back 撤销一次加载。各列可像 Excel 一样排序和筛选。',
  tourCustT: '4. New customers：填写并 Add', tourSkusT: '5. New SKUs：填写并 Add', tourSkusB: '来源发来而门户不认识的 SKU。Translate names to English 将韩文名称译成英文；输入缺少的内容，Save 保留输入，Add 写入 SKU 并加载为其保留的行。', tourPendingB: '来源发来而门户不认识的客户或 SKU。输入缺少的内容，Save 保留输入，Add 写入维度表并加载为其保留的行。',
  tourHeldT: '6. 保留的行', tourHeldB: '运行无法加载的行——未知客户或 SKU、未映射的渠道、范围外的日期。Load held rows 加载客户和 SKU 现已存在的行。',
  tourHjpnT: '8. HJPN 工作簿', tourHjpnB: '选择文件，Preview 读取，Load HJPN 替换范围内的 HJPN。范围外的行不受影响。',
  nOfN: '{{total}} 行中的 {{n}} 行', clearFilters: '清除筛选',
  translate: '将名称翻译为英文', translateHint: '韩文名称由 Claude 翻译；原文保留在 Source said 列。', translated: '已翻译 {{n}} 个名称，{{left}} 个保持原样', translateNoAi: '此服务器没有 AI 密钥——名称保持原样。',
  loadHeld: '加载暂挂行', heldLoaded: '已加载 {{n}} 行，仍暂挂 {{left}} 行。', colDate: '日期', colDoc: '单据', colCustomer: '客户', colChannel: '渠道', colReason: '原因',
  hjpnHint: '手工维护的 HJPN 工作簿（工作表 "REVENUE - B&M SALE" 和 "REVENUE - ONLINE <年份>"）。范围内的行会替换事实表中该范围的 HJPN，其他不动。',
  chooseFile: '选择工作簿…', hjpnPreview: '预览', hjpnLoad: '加载 HJPN', hjpnConfirm: '用此工作簿的行替换 {{from}} 到 {{to}} 的 HJPN？',
  issues: '数字对不上的行（笔记本会在此停止；这里按工作表加载并列出）：', working: '处理中…', done: '完成。', error: '错误',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "title": "Mise à jour des données de ventes",
  "sub": "SAP (HINC) et NetSuite (HUSA, HEMA, HPAC) sont lus directement ; le classeur HJPN est importé. La fenêtre va du lendemain de la date de clôture (à défaut, le 1er du mois dernier) jusqu'à hier.",
  "window": "Fenêtre",
  "cronOn": "S'exécute automatiquement chaque matin à 06:15",
  "cronOff": "L'exécution du matin n'est pas armée sur ce serveur",
  "running": "Un chargement est en cours…",
  "tab_runs": "Exécutions",
  "tab_customers": "Nouveaux clients",
  "tab_skus": "Nouveaux SKU",
  "tab_held": "Lignes en attente",
  "tab_hjpn": "Classeur HJPN",
  "from": "Du",
  "to": "Au",
  "sources": "Sources",
  "preview": "Aperçu (sans modification)",
  "load": "Charger dans la table de faits",
  "loadConfirm": "Remplacer les ventes de {{regions}} du {{from}} au {{to}} dans 03_ERP_TransactionSalesCW_ft par ce que SAP et NetSuite contiennent actuellement ? Les lignes remplacées sont conservées et peuvent être restaurées.",
  "loadOk": "Charger",
  "colRun": "Exécution",
  "colWhen": "Démarrée",
  "colStatus": "Statut",
  "colBy": "Par",
  "colRange": "Période",
  "colSources": "Sources",
  "colRows": "Lignes",
  "colResult": "Résultat",
  "colAction": "Action",
  "st_running": "En cours",
  "st_ok": "Chargé",
  "st_dry": "Aperçu",
  "st_would": "Serait chargé",
  "st_partial": "Partiellement chargé",
  "st_error": "Échec",
  "st_rolled_back": "Restauré",
  "trig_cron": "Exécution du matin",
  "trig_manual": "Manuelle",
  "trig_hjpn": "Import HJPN",
  "trig_held": "Lignes en attente",
  "rowsLine": "{{loaded}} à charger · {{held}} en attente",
  "detail": "Détails",
  "putBack": "Restaurer",
  "putBackConfirm": "Supprimer ce que l'exécution n° {{id}} a chargé et restaurer les lignes qu'elle a remplacées ?",
  "before": "Dans la table avant",
  "staged": "Cette exécution",
  "region": "Entité",
  "rows": "Lignes",
  "qty": "Qté",
  "net": "Net",
  "days": "Jours",
  "internalRows": "Intercompany",
  "exInternal": "hors intercompany",
  "exInternalHint": "La quantité et le net excluent les lignes intercompany ; Lignes compte toutes les lignes et Intercompany indique combien sont internes.",
  "inclInternalOld": "Exécution ancienne : ce chiffre inclut encore les lignes intercompany. Cliquez de nouveau sur Aperçu pour obtenir le chiffre sans elles.",
  "lastDay": "Dernier jour",
  "heldWhy": "Pourquoi des lignes ont été mises en attente",
  "log": "Journal",
  "noRuns": "Aucune exécution pour l'instant.",
  "refresh": "Actualiser",
  "factNow": "Dans la table de faits actuellement",
  "custHint": "Clients auxquels les sources vendent et que 02_ERP_Customer_ft ne connaît pas. Renseignez ce que la source n'a pas pu indiquer, puis Ajouter — les lignes en attente pour ce client sont chargées immédiatement.",
  "skuHint": "SKU vendus par les sources que 01_PLM_Product_ft ne connaît pas. Renseignez au moins la description et la collection, puis Ajouter — les lignes en attente pour ce SKU sont chargées immédiatement.",
  "colId": "ID",
  "colName": "Nom",
  "colNameKr": "Nom (KR)",
  "colSourceType": "Selon la source",
  "colType": "Type de client",
  "colTypeCw": "Type (CW)",
  "colDistrict": "District",
  "colCity": "Ville",
  "colState": "État / province",
  "colCountry": "Pays",
  "colHeld": "Lignes en attente",
  "colSeen": "Vu dans l'exécution",
  "save": "Enregistrer",
  "add": "Ajouter",
  "dismiss": "Ignorer",
  "dismissed": "Ignoré",
  "added": "Ajouté",
  "noPending": "Rien en attente.",
  "colSku": "SKU",
  "colSapCode": "Code SAP",
  "colDesc": "Description",
  "colColorway": "Coloris",
  "colSize": "Taille",
  "colCollection": "Collection",
  "colFrameModel": "Modèle de cadre",
  "colFrameColor": "Couleur du cadre",
  "colCategory": "Catégorie NS",
  "colNsType": "Type NS",
  "colSubtype": "Sous-type NS",
  "colRef": "Selon la source",
  "pick": "— choisir —",
  "heldHint": "Lignes calculées mais non chargées, chacune avec son motif. Dès que le client ou le SKU existe, « Charger les lignes en attente » les intègre sans toucher au reste. Une ligne mise en attente par un Aperçu n'est pas chargée de cette façon — le prochain chargement la relit depuis la source.",
  "loadHeldConfirm": "Charger dans la table de faits les lignes en attente dont le client et le SKU existent désormais ? {{n}} lignes sont en attente ; seules celles qui sont résolues sont intégrées, rien n'est supprimé.",
  "flashCounts": "{{n}} {{what}} / {{held}} en attente",
  "heldPreview": "{{n}} lignes en attente proviennent d'un Aperçu — cliquez sur « Charger dans la table de faits » : elles sont relues depuis la source, le client et le SKU étant désormais connus.",
  "closedThrough": "Clôturé jusqu'au",
  "closedHint": "Le dernier jour déjà validé. Un chargement commence le lendemain ; l'exécution du matin aussi.",
  "closedLine": "Les ventes jusqu'au {{day}} sont clôturées — un chargement commence le {{from}}.",
  "closedNone": "Pas encore de date de clôture — la fenêtre va du 1er du mois dernier jusqu'à hier.",
  "closedSaved": "Clôturé jusqu'au {{day}} — les chargements commencent le {{from}}.",
  "cacheNote": "le cache de Sales Report est en cours d'actualisation en arrière-plan (environ 5 minutes) — le tableau de bord affichera les nouveaux chiffres une fois terminé",
  "cacheRefreshing": "Actualisation du cache de Sales Report…",
  "cacheDone": "cache {{s}} s",
  "cacheFailed": "échec de l'actualisation du cache",
  "tourTabsT": "Cinq onglets, un seul flux — ce guide les parcourt dans l'ordre",
  "tourTabsB": "Exécutions est l'endroit où un chargement est prévisualisé et lancé. Nouveaux clients et Nouveaux SKU contiennent ce que les sources ont envoyé et que le portail ne connaît pas encore — renseignez-les et cliquez sur Ajouter, et les lignes en attente pour eux sont chargées. Lignes en attente liste ce qui attend. Classeur HJPN importe le fichier que vous tenez à jour à la main.",
  "tourClosedT": "1. Définir la date de clôture",
  "tourClosedB": "Le dernier jour déjà validé. La fenêtre commence le lendemain et un chargement sur un jour clôturé est refusé. Avancez-la une fois qu'un mois est définitif.",
  "tourWindowT": "2. Vérifier la fenêtre et les sources",
  "tourWindowB": "Du et Au sont les jours lus depuis SAP (HINC) et NetSuite (HUSA, HEMA, HPAC). Du est par défaut le lendemain de la date de clôture, Au est par défaut hier.",
  "tourPreviewT": "3. Preview",
  "tourPreviewB": "Lit les sources et prépare chaque ligne sans toucher à la table de faits. La ligne d'exécution indique combien seraient chargées et combien sont en attente pour un client ou un SKU inconnu.",
  "tourLoadT": "7. Charger dans la table de faits",
  "tourLoadB": "Remplace la fenêtre dans la table de faits — après une sauvegarde, en une seule transaction — puis le cache de Sales Report est actualisé en arrière-plan (environ 5 minutes). Restaurer sur la ligne d'exécution rétablit la sauvegarde.",
  "tourFactT": "9. Vérifier ce que contient la table de faits",
  "tourFactB": "Par région : combien de lignes se trouvent dans la fenêtre et le dernier jour de vente chargé. Comparez avec un Aperçu avant de charger.",
  "tourRunsT": "10. Toutes les exécutions, et Restaurer",
  "tourRunsB": "Aperçu et Chargement confondus. Détails ouvre les lignes préparées et le journal ; Restaurer annule un chargement. Triez et filtrez les colonnes comme dans Excel.",
  "tourCustT": "4. Nouveaux clients : renseigner et Ajouter",
  "tourSkusT": "5. Nouveaux SKU : renseigner et Ajouter",
  "tourSkusB": "Un SKU envoyé par les sources et inconnu du portail. Traduire les noms convertit en anglais un nom coréen ; saisissez ce qui manque, Enregistrer conserve votre saisie, Ajouter écrit le SKU et charge les lignes en attente pour lui.",
  "tourPendingB": "Un client ou un SKU envoyé par les sources et inconnu du portail. Saisissez ce qui manque, Enregistrer conserve votre saisie, Ajouter l'écrit dans la dimension et charge les lignes en attente pour lui.",
  "tourHeldT": "6. Lignes en attente",
  "tourHeldB": "Lignes qu'une exécution n'a pas pu charger — client ou SKU inconnu, canal non mappé, date hors fenêtre. Charger les lignes en attente reprend celles dont le client et le SKU existent désormais.",
  "tourHjpnT": "8. Le classeur HJPN",
  "tourHjpnB": "Choisissez le fichier, Aperçu pour le lire, Charger HJPN pour remplacer HJPN dans la fenêtre. Les lignes hors fenêtre ne sont pas modifiées.",
  "nOfN": "{{n}} sur {{total}} lignes",
  "clearFilters": "Effacer les filtres",
  "translate": "Traduire les noms en anglais",
  "translateHint": "Un nom coréen est traduit par Claude ; l'original reste sous Selon la source.",
  "translated": "{{n}} noms traduits, {{left}} laissés tels quels",
  "translateNoAi": "Aucune clé AI sur ce serveur — les noms restent tels quels.",
  "loadHeld": "Charger les lignes en attente",
  "heldLoaded": "{{n}} lignes chargées, {{left}} toujours en attente.",
  "colDate": "Date",
  "colDoc": "Document",
  "colCustomer": "Client",
  "colChannel": "Canal",
  "colReason": "Motif",
  "hjpnHint": "Le classeur HJPN que vous tenez à jour à la main (feuilles « REVENUE - B&M SALE » et « REVENUE - ONLINE <year> »). Les lignes comprises dans la fenêtre remplacent HJPN dans la table de faits pour cette fenêtre ; rien d'autre n'est modifié.",
  "chooseFile": "Choisir le classeur…",
  "hjpnPreview": "Aperçu",
  "hjpnLoad": "Charger HJPN",
  "hjpnConfirm": "Remplacer HJPN du {{from}} au {{to}} par les lignes de ce classeur ?",
  "issues": "Lignes dont les chiffres ne concordent pas (le notebook s'est arrêté sur celles-ci ; elles sont ici listées et chargées telles que la feuille les indique) :",
  "working": "Traitement en cours…",
  "done": "Terminé.",
  "error": "Erreur"
};
const ja = {
  "title": "売上データ更新",
  "sub": "SAP（HINC）とNetSuite（HUSA、HEMA、HPAC）は直接取得し、HJPNのワークブックはアップロードします。対象期間は、締め日の翌日（なければ前月1日）から昨日までです。",
  "window": "対象期間",
  "cronOn": "毎朝06:15に自動実行されます",
  "cronOff": "このサーバーでは朝の自動実行は有効になっていません",
  "running": "ロード実行中…",
  "tab_runs": "実行履歴",
  "tab_customers": "新規顧客",
  "tab_skus": "新規SKU",
  "tab_held": "保留行",
  "tab_hjpn": "HJPNワークブック",
  "from": "開始",
  "to": "終了",
  "sources": "ソース",
  "preview": "プレビュー（変更なし）",
  "load": "ファクトテーブルにロード",
  "loadConfirm": "{{from}}から{{to}}までの{{regions}}の売上を、03_ERP_TransactionSalesCW_ftにあるデータから、現在SAPとNetSuiteにあるデータへ置き換えますか？置き換えられた行は保持され、元に戻せます。",
  "loadOk": "ロード",
  "colRun": "実行",
  "colWhen": "開始日時",
  "colStatus": "ステータス",
  "colBy": "実行者",
  "colRange": "期間",
  "colSources": "ソース",
  "colRows": "行数",
  "colResult": "結果",
  "colAction": "操作",
  "st_running": "実行中",
  "st_ok": "ロード済み",
  "st_dry": "プレビュー",
  "st_would": "ロード予定",
  "st_partial": "一部ロード済み",
  "st_error": "失敗",
  "st_rolled_back": "復元済み",
  "trig_cron": "朝の自動実行",
  "trig_manual": "手動",
  "trig_hjpn": "HJPNアップロード",
  "trig_held": "保留行",
  "rowsLine": "ロード対象{{loaded}}件・保留{{held}}件",
  "detail": "詳細",
  "putBack": "元に戻す",
  "putBackConfirm": "実行#{{id}}でロードした内容を削除し、置き換えられた行を元に戻しますか？",
  "before": "テーブル内（実行前）",
  "staged": "今回の実行",
  "region": "法人",
  "rows": "行数",
  "qty": "数量",
  "net": "正味",
  "days": "日数",
  "internalRows": "社内取引",
  "exInternal": "社内取引を除く",
  "exInternalHint": "数量と正味は社内取引の行を除外しています。行数はすべての行を数え、社内取引はそのうち社内の件数を示します。",
  "inclInternalOld": "以前の実行です。この数値には社内取引の行がまだ含まれています。除外した数値を見るには、もう一度プレビューを押してください。",
  "lastDay": "最終日",
  "heldWhy": "行が保留された理由",
  "log": "ログ",
  "noRuns": "実行履歴はまだありません。",
  "refresh": "更新",
  "factNow": "現在のファクトテーブル内",
  "custHint": "ソースが販売している顧客のうち、02_ERP_Customer_ftに登録されていないものです。ソースから取得できなかった項目を入力して「追加」を押すと、その顧客で保留されていた行がすぐにロードされます。",
  "skuHint": "ソースが販売したSKUのうち、01_PLM_Product_ftに登録されていないものです。少なくとも説明とコレクションを入力して「追加」を押すと、そのSKUで保留されていた行がすぐにロードされます。",
  "colId": "ID",
  "colName": "名称",
  "colNameKr": "名称（KR）",
  "colSourceType": "ソースの記載",
  "colType": "顧客タイプ",
  "colTypeCw": "タイプ（CW）",
  "colDistrict": "地区",
  "colCity": "市区町村",
  "colState": "州／県",
  "colCountry": "国",
  "colHeld": "保留行数",
  "colSeen": "確認された実行",
  "save": "保存",
  "add": "追加",
  "dismiss": "無視",
  "dismissed": "無視済み",
  "added": "追加済み",
  "noPending": "待機中のものはありません。",
  "colSku": "SKU",
  "colSapCode": "SAPコード",
  "colDesc": "説明",
  "colColorway": "カラーウェイ",
  "colSize": "サイズ",
  "colCollection": "コレクション",
  "colFrameModel": "フレームモデル",
  "colFrameColor": "フレームカラー",
  "colCategory": "NSカテゴリ",
  "colNsType": "NSタイプ",
  "colSubtype": "NSサブタイプ",
  "colRef": "ソースの記載",
  "pick": "— 選択 —",
  "heldHint": "処理済みですがロードされていない行で、それぞれ理由が付いています。顧客またはSKUが登録されたら、「保留行をロード」でほかのデータに影響を与えずに取り込めます。プレビューで保留になった行はこの方法ではロードされません。次回のロード時にソースから再取得されます。",
  "loadHeldConfirm": "顧客とSKUが登録済みになった保留行を、ファクトテーブルにロードしますか？保留は{{n}}行あり、解決できたものだけが取り込まれます。削除されるものはありません。",
  "flashCounts": "{{n}}{{what}}／保留{{held}}件",
  "heldPreview": "保留行{{n}}件はプレビューによるものです。「ファクトテーブルにロード」を押してください。顧客とSKUが登録済みの状態でソースから再取得されます。",
  "closedThrough": "締め日",
  "closedHint": "承認済みの最終日です。ロードはその翌日から始まり、朝の自動実行も同様です。",
  "closedLine": "{{day}}までの売上は締め済みです。ロードは{{from}}から開始します。",
  "closedNone": "締め日はまだありません。対象期間は前月1日から昨日までです。",
  "closedSaved": "{{day}}まで締め済みにしました。ロードは{{from}}から開始します。",
  "cacheNote": "Sales Reportのキャッシュをバックグラウンドで更新中です（約5分）。終了すると、ダッシュボードに新しい数値が表示されます",
  "cacheRefreshing": "Sales Reportのキャッシュを更新中…",
  "cacheDone": "キャッシュ {{s}}秒",
  "cacheFailed": "キャッシュの更新に失敗しました",
  "tourTabsT": "5つのタブ、ひと続きの流れ：このガイドで順に説明します",
  "tourTabsB": "実行履歴では、ロードのプレビューと開始を行います。新規顧客と新規SKUには、ソースから送られてきたもののポータルにまだ登録がないものが入ります。入力して「追加」を押すと、保留されていた行がロードされます。保留行では待機中の行を確認できます。HJPNワークブックでは、手作業で管理しているファイルをアップロードします。",
  "tourClosedT": "1. 締め日を設定する",
  "tourClosedB": "承認済みの最終日です。対象期間はその翌日から始まり、締め済みの日へのロードは拒否されます。月が確定したら、先へ進めてください。",
  "tourWindowT": "2. 対象期間とソースを確認する",
  "tourWindowB": "開始と終了は、SAP（HINC）とNetSuite（HUSA、HEMA、HPAC）から取得する日付です。開始の初期値は締め日の翌日、終了の初期値は昨日です。",
  "tourPreviewT": "3. Preview",
  "tourPreviewB": "ファクトテーブルには触れずに、ソースを読み込んですべての行を準備します。実行行には、ロードされる件数と、顧客またはSKUが未登録のため保留になる件数が表示されます。",
  "tourLoadT": "7. ファクトテーブルにロード",
  "tourLoadB": "バックアップ後、1つのトランザクションでファクトテーブルの対象期間を置き換えます。その後、Sales Reportのキャッシュをバックグラウンドで更新します（約5分）。実行行の「元に戻す」でバックアップを復元できます。",
  "tourFactT": "9. ファクトテーブルの現在の内容を確認する",
  "tourFactB": "地域ごとに、対象期間内の行数と、ロード済みの最終売上日を表示します。ロードの前にプレビューと比較してください。",
  "tourRunsT": "10. すべての実行履歴と「元に戻す」",
  "tourRunsB": "プレビューもロードも含みます。「詳細」で準備された行とログを開き、「元に戻す」でロードを取り消します。列はExcelのように並べ替え・フィルターができます。",
  "tourCustT": "4. 新規顧客：入力して「追加」",
  "tourSkusT": "5. 新規SKU：入力して「追加」",
  "tourSkusB": "ソースから送られてきたものの、ポータルに登録がないSKUです。「名称を英語に翻訳」で韓国語の名称を英語にできます。不足している項目を入力し、「保存」で入力内容を保持、「追加」でSKUを登録し、保留されていた行をロードします。",
  "tourPendingB": "ソースから送られてきたものの、ポータルに登録がない顧客またはSKUです。不足している項目を入力し、「保存」で入力内容を保持、「追加」でディメンションに登録し、保留されていた行をロードします。",
  "tourHeldT": "6. 保留行",
  "tourHeldB": "実行でロードできなかった行です。顧客またはSKUが未登録、チャネルが未マッピング、日付が対象期間外などが原因です。「保留行をロード」で、顧客とSKUが登録済みになった行を取り込みます。",
  "tourHjpnT": "8. HJPNワークブック",
  "tourHjpnB": "ファイルを選択し、「プレビュー」で読み込み、「HJPNをロード」で対象期間内のHJPNを置き換えます。対象期間外の行には影響しません。",
  "nOfN": "{{total}}行中{{n}}行",
  "clearFilters": "フィルターをクリア",
  "translate": "名称を英語に翻訳",
  "translateHint": "韓国語の名称はClaudeが翻訳します。元の名称は「ソースの記載」に残ります。",
  "translated": "{{n}}件の名称を翻訳、{{left}}件はそのまま",
  "translateNoAi": "このサーバーにはAIキーがありません。名称は元のままです。",
  "loadHeld": "保留行をロード",
  "heldLoaded": "{{n}}行をロードしました。{{left}}行は保留のままです。",
  "colDate": "日付",
  "colDoc": "伝票",
  "colCustomer": "顧客",
  "colChannel": "チャネル",
  "colReason": "理由",
  "hjpnHint": "手作業で管理しているHJPNのワークブックです（シート「REVENUE - B&M SALE」と「REVENUE - ONLINE <year>」）。対象期間内の行は、その期間のファクトテーブル内のHJPNを置き換えます。ほかのデータには影響しません。",
  "chooseFile": "ワークブックを選択…",
  "hjpnPreview": "プレビュー",
  "hjpnLoad": "HJPNをロード",
  "hjpnConfirm": "{{from}}から{{to}}までのHJPNを、このワークブックの行で置き換えますか？",
  "issues": "数値が合わない行です（ノートブックではここで処理が止まりましたが、ここでは一覧表示し、シートの内容どおりにロードします）：",
  "working": "処理中…",
  "done": "完了しました。",
  "error": "エラー"
};

export default { ns: 'xSalesCw', en, ko, vi, zh, fr, ja };
